<template>
  <table class='table-common'>
    <thead>
      <tr>
        <th rowspan='2'>Вид использования или категория защитных лесов</th>
        <th colspan='7'>Преобладающая порода</th>
      </tr>
      <tr>
        <th>Ель, пихта</th>
        <th>Кедр</th>
        <th>Сосна</th>
        <th>Лиственница</th>
        <th>Дуб</th>
        <th>Каштан</th>
        <th>Береза и прочие лиственные</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan='8' class='table-section'>Резервные леса</td>
      </tr>
      <tr>
        <td>Нет</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>-</td>
        <td>-</td>
        <td>0.3</td>
      </tr>

      <tr>
        <td colspan='8' class='table-section'>Эксплуатационные леса</td>
      </tr>
      <tr>
        <td>Заготовка древесины</td>
        <td>0.5</td>
        <td>-</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>-</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>Заготовка живицы</td>
        <td>-</td>
        <td>-</td>
        <td>0.3</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
      </tr>
      <tr>
        <td>Заготовка и сбор недревесных ресурсов</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>Заготовка пищевых лесных ресурсов и сбор лекарственных растений</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>Научно-исследовательская и образовательная деятельность</td>
        <td colspan='7'>Не лимитируется</td>
      </tr>
      <tr>
        <td>Осуществление рекреационной деятельности</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>Эксплуатация лесных плантаций</td>
        <td colspan='7'>Не лимитируется</td>
      </tr>
      <tr>
        <td>Прочие виды использования</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>

      <tr>
        <td colspan='8' class='table-section'>Защитные леса</td>
      </tr>
      <tr>
        <td>1. Леса, расположенные в водоохранных зонах</td>
        <td colspan='7'>Не лимитируется для дуба, каштана и кедра, для остальных пород 0,3</td>
      </tr>
      <tr>
        <td>2. Леса, выполняющие функции защиты природных и иных объектов: а) леса, расположенные в первом и втором поясах зон санитарной охраны источников питьевого и хозяйственно-бытового водоснабжения (леса, расположенные в границах соответствующих поясов зон санитарной охраны источников питьевого и хозяйственно-бытового водоснабжения, установленных в соответствии с требованиями законодательства в области обеспечения санитарно-эпидемиологического благополучия населения);</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>б) леса, расположенные в защитных полосах лесов (леса, расположенные в границах полос отвода железных дорог и придорожных полос автомобильных дорог, установленных в соответствии с законодательством Российской Федерации о железнодорожном транспорте, законодательством об автомобильных дорогах и о дорожной деятельности);</td>
        <td>0.6</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
      </tr>
      <tr>
        <td>в) леса, расположенные в зеленых зонах (леса, расположенные на землях лесного фонда и землях иных категорий, выделяемые в целях обеспечения защиты населения от воздействия неблагоприятных явлений природного и техногенного происхождения, сохранения и восстановления окружающей среды);</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>г) леса, расположенные в лесопарковых зонах (леса, расположенные на землях лесного фонда и землях иных категорий, используемые в целях организации отдыха населения, сохранения санитарно-гигиенической, оздоровительной функций и эстетической ценности природных ландшафтов);</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>д) горно-санитарные леса (леса, расположенные в границах зон округов санитарной (горносанитарной) охраны лечебно-оздоровительных местностей и курортов, установленных в соответствии с законодательством Российской Федерации о природных лечебных ресурсах, лечебно-оздоровительных местностях и курортах).</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>3. Ценные леса: а) государственные защитные лесные полосы (леса линейного типа, искусственно созданные в лесостепных, степных зонах, зонах полупустынь и пустынь, выполняющие климаторегулирующие, почвозащитные, противоэрозионные и водорегулирующие функции);</td>
        <td>0.6</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
        <td>0.5</td>
      </tr>
      <tr>
        <td>б) противоэрозионные леса (леса, предназначенные для охраны земель от эрозии)</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.5</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>в) пустынные, полупустынные леса (леса, расположенные в зоне полупустынь и пустынь, выполняющие защитные функции);</td>
        <td colspan='7'>Не лимитируется для пустынных, полупустынных и малолесных горных территорий. В остальных случаях - 0,3 для всех пород</td>
      </tr>
      <tr>
        <td>г) леса, имеющие научное или историко-культурное значение (леса, расположенные на землях историко-культурного назначения и в зонах охраны объектов культурного наследия, леса, являющиеся объектами исследований генетических качеств деревьев, кустарников и лиан (генетические резерваты), образцами достижений лесохозяйственной науки и практики, а также уникальные по продуктивности леса);</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>д) леса, расположенные в орехово-промысловых зонах (леса, являющиеся сырьевой базой для заготовки кедровых орехов);</td>
        <td colspan='7'>Не лимитируется</td>
      </tr>
      <tr>
        <td>е) лесные плодовые насаждения (леса, в составе которых произрастают ценные плодово-ягодные и орехоплодные породы деревьев и кустарников)</td>
        <td colspan='7'>Не лимитируется</td>
      </tr>
      <tr>
        <td>ж) ленточные боры (леса, исторически сформировавшиеся в жестких почвенно-климатических условиях среди безлесных степных, полупустынных и пустынных пространств, имеющие важное климаторегулирующее, почвозащитное и водоохранное значение);</td>
        <td>-</td>
        <td>-</td>
        <td>0.2</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>з) запретные полосы лесов, расположенные вдоль водных объектов (леса, примыкающие непосредственно к руслу реки или берегу другого водного объекта, а при безлесной пойме - к пойме реки, выполняющие водорегулирующие функции);</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>и) нерестоохранные полосы лесов (леса, расположенные в границах рыбоохранных зон или рыбохозяйственных заповедных зон, установленных в соответствии с законодательством о рыболовстве и сохранении водных биологических ресурсов).</td>
        <td>0.5</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>4. Городские леса</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
        <td>0.3</td>
      </tr>
      <tr>
        <td>5. Особо защитные участки лесов</td>
        <td colspan='7'>Не лимитируется</td>
      </tr>
    </tbody>
  </table>
</template>

<script>

  export default {
    name: 'MzlCriticalDensityParamsTable'
  };
</script>

<style src='@/style/table.css'></style>

<style scoped>
  .table-section {
    font-weight: bold;
  }
</style>